let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lBiSz")).then(() => parcelRequire('ef0Q5'));